import FeatureIDs from "../../Utils/Common/FeatureIDs";
import {
  complexQuery,
  getData,
  recalculateAggregateScore,
} from "../../Utils/Common/Library";
import { constants } from "./Dimension/Data/QueryConstants";

export const loadPlan = async (eppId, eppDoc, status) => {
  try {
    let EPP = eppDoc;
    if (!EPP) {
      const eppRes = await getData({
        featureId: FeatureIDs.EmployeePerformancePlan,
        payload: {
          "Header.TransactionID": eppId,
        },
      });
      if (typeof eppRes === "string") {
        return null;
      } else {
        EPP = eppRes.Data[0];
      }
    }

    if (!EPP) return null;
    const MPPID = EPP?.MasterPerformancePlanID;
    if (!MPPID) return null;

    const dimensions = EPP.Dimensions;
    const promises = [
      getData({
        featureId: FeatureIDs.MasterPerformancePlan,
        payload: {
          "Header.TransactionID": MPPID,
        },
      }),
      getData({
        featureId: FeatureIDs.ConfidentialAssessment,
        payload: {
          "Data.AppraiseeUserID": EPP.AppraiseeUserID,
          "Data.EmployeePlanID": EPP.TransactionID,
        },
      }),
      ...dimensions.map((d) =>
        complexQuery({
          RequiredFields: [
            { EmployeePerformancePlanID: EPP.TransactionID },
            { DimensionID: d.DimensionID },
          ],
          QueryName: constants.QueryName,
        })
      ),
    ];
    const [mppRes, confRes, ...dimensionsRes] = await Promise.all(promises);
    const MPP = mppRes?.Data[0];
    if (!MPP) {
      return null;
    }
    const Dimensions = {};
    if (dimensionsRes && dimensionsRes.length > 0) {
      dimensionsRes.forEach((d) => {
        const data = d[0];
        if (data) {
          Dimensions[data.DimensionID] = data;
        }
      });
    }
    const Confidential = (confRes?.Data || [])[0] || null;
    return { EPP, MPP, Dimensions, Confidential, CurrentStatus: status };
  } catch (e) {
    console.log(e);
    return null;
  }
};

const isFilledAndOtherEmptyOrZero = (v1, v2) => {
  const n1 = parseFloat(v1);
  const n2 = parseFloat(v2);
  const hasValue1 = v1 !== undefined && v1 !== "" && !isNaN(n1) && n1 > 0;
  const hasValue2 = v2 !== undefined && v2 !== "" && !isNaN(n2) && n2 > 0;
  return hasValue1 && !hasValue2 ? 2 : !hasValue1 && hasValue2 ? 1 : 0;
};

export const recalculateScore = async (paDocId, eppId) => {
  try {
    console.log("DEBUGGING_PA_DOC_ID_EXISTS");
    await recalculateAggregateScore(paDocId);
    await new Promise((resolve) => setTimeout(resolve, 2000));
    const data = await loadPlan(eppId, null);
    console.log(data, "RELOADED_PLAN_DATA");
    if (!data || data === null) {
      return null;
    } else {
      return data;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const reloadPlanBasedOnScores = async (eppId, prevData) => {
  try {
    const { EPP: epp, Dimensions: planDimensions } = prevData || {};
    const dimensions = epp?.Dimensions || [];
    if (dimensions.length === 2) {
      const d1 = dimensions[0];
      const d2 = dimensions[1];
      let value1 = "",
        value2 = "";
      if (d1) {
        value1 = d1.DimensionAggregateScore?.AppraiserAggregateScore;
      }
      if (d2) {
        value2 = d2.DimensionAggregateScore?.AppraiserAggregateScore;
      }
      console.log(value1, value2, "DEBUGGING_VALUES");
      const flag = isFilledAndOtherEmptyOrZero(value1, value2);
      console.log(flag, "DEBUGGING_FLAG");
      const dimensionId =
        flag === 2 ? d2?.DimensionID : flag === 1 ? d1?.DimensionID : null;

      if (dimensionId) {
        console.log(dimensionId, "DEBUGGING_DIMENSION_ID");
        const paDocId =
          ((planDimensions || {})[dimensionId]?.ParameterAssessments || [])[0]
            ?.Header?.DocumentID || null;
        console.log(paDocId, "DEBUGGING_PA_DOC_ID");
        if (paDocId) {
          return await recalculateScore(paDocId, eppId);
        }
      }

      const pa1 = ((planDimensions || {})[d1.DimensionID]
        ?.ParameterAssessments || [])[0];
      const pa2 = ((planDimensions || {})[d2.DimensionID]
        ?.ParameterAssessments || [])[0];

      console.log(pa1, pa2, "DEBUGGING_PA_DOCS");

      let goalsScore = null;
      let coreScore = null;
      if (pa1) {
        goalsScore =
          (pa1.Data?.PeriodAggregateScore || []).find(
            (p) => p.ActorType === "Appraiser"
          )?.AggregateScore || null;
      }
      if (pa2) {
        coreScore =
          (pa2.Data?.PeriodAggregateScore || []).find(
            (p) => p.ActorType === "Appraiser"
          )?.AggregateScore || null;
      }

      console.log(goalsScore, coreScore, "DEBUGGING_SCORES");

      let paDocId = null;
      if (goalsScore && value1 && goalsScore !== value1) {
        paDocId = pa1?.Header?.DocumentID || null;
      }
      if (coreScore && value2 && coreScore !== value2) {
        paDocId = pa2?.Header?.DocumentID || null;
      }

      console.log(paDocId, "DEBUGGING_PA_DOC_ID");
      if (paDocId) {
        return await recalculateScore(paDocId, eppId);
      }
    }
    return null;
  } catch (e) {
    console.log(e);
    return null;
  }
};
